__turbopack_context__.v({
  "box": "index-module-scss-module__PO5YWa__box",
  "button": "index-module-scss-module__PO5YWa__button",
  "copy": "index-module-scss-module__PO5YWa__copy",
  "edit": "index-module-scss-module__PO5YWa__edit",
  "error": "index-module-scss-module__PO5YWa__error",
  "errorText": "index-module-scss-module__PO5YWa__errorText",
  "field": "index-module-scss-module__PO5YWa__field",
  "fields": "index-module-scss-module__PO5YWa__fields",
  "input": "index-module-scss-module__PO5YWa__input",
  "needsConfirm": "index-module-scss-module__PO5YWa__needsConfirm",
  "row": "index-module-scss-module__PO5YWa__row",
  "ticketNumber": "index-module-scss-module__PO5YWa__ticketNumber",
  "ticketRows": "index-module-scss-module__PO5YWa__ticketRows",
});
